












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ChevronSvg extends Vue {
  @Prop(Boolean) private readonly active!: boolean | undefined;
}
